import { UAParser } from 'ua-parser-js';

function fixFooterNav() {
    const navEl: HTMLElement = document.querySelector('ul.mobile-navi');
    if (!navEl) {
        return;
    }

    // 機器判定クラスの初期化
    const parser = new UAParser(window.navigator.userAgent);
    const result = parser.getResult();

    // iOSでPWAモードの場合、またはiPad (mini)、もしくはiPad Pro (Air)
    if (
        (result.os.name == 'iOS' && window.matchMedia('(display-mode: standalone)').matches) ||
        result.device.model == 'iPad' ||
        (result.os.name == 'Mac OS' && 'ontouchend' in document)
    ) {
        navEl.classList.add('pb-2');
    }
}

fixFooterNav();
